import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../../../components/Loading';
import PastorProfileView from '../components/PastorProfileView';
import { deliveredFileUrl, pastorApi, errorMessage } from '../pastorApi';
import type { PastorProfile } from '../pastorApi';

// 교회가 이메일 링크로 여는 후보 이력서 (로그인 없이, 링크를 받은 교회만)
export default function DeliveredView() {
  const { token = '' } = useParams();
  const [data, setData] = useState<{ churchName: string; deliveredAt: string; profile: PastorProfile } | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    pastorApi.delivered(token).then(setData).catch((e) => setError(errorMessage(e, '이력서를 열 수 없습니다.')));
  }, [token]);

  if (error) {
    return (
      <div className="pastor-call inner pc-page">
        <div className="pc-gate"><p className="pc-gate__title">{error}</p><p>문의는 오른쪽 아래 [청빙 대행 상담]으로 해 주세요.</p></div>
      </div>
    );
  }
  if (!data) return <div className="pastor-call inner pc-page"><Loading /></div>;
  const p = data.profile;

  return (
    <div className="pastor-call inner pc-page pc-delivered">
      <div className="pc-page__head">
        <h2>{p.realName} 목사님 이력서</h2>
        <div className="pc-page__tools">
          <button type="button" className="mm-btn mm-btn--outline pc-btn-sm" onClick={() => window.print()}>인쇄</button>
        </div>
      </div>
      <div className="pc-contact">
        <p className="pc-contact__title">{data.churchName} 담당자님께 사역자모아가 전달드리는 이력서입니다 ({data.deliveredAt?.slice(0, 10)})</p>
        <p>목사님이 이 교회에 이력서 전달을 동의하셨습니다. 연락처 <b>{p.phone}</b>{p.email ? ` · ${p.email}` : ''}</p>
        <p className="pc-hint">목사님의 현재 사역지에 알려지지 않도록 첫 연락은 개인 연락처로 해 주시고, 이 링크를 다른 곳에 공유하지 말아 주세요.</p>
      </div>
      <PastorProfileView profile={p} onOpenFile={(f) => { window.location.href = deliveredFileUrl(token, f.id); }} />
    </div>
  );
}
